<div class="grid-x forecast" [class.loading-overlay]="loading">
  @if (forecast?.immobilie_wertsteigerung_prozent?.min > 0 && forecast?.immobilie_wertsteigerung_prozent?.max > 0) {
    <div class="cell medium-4 value-increase">
      <img src="/gfx/moc/wertsteigerung_immobilie.jpg" alt="">
      <div class="cell-content">
        <span [innerHTML]="textkeyPrefix + 'wertsteigerung' | translate"></span>
        <strong>
          @if (forecast?.immobilie_wertsteigerung_prozent?.min !== forecast?.immobilie_wertsteigerung_prozent?.max) {
            {{ forecast?.immobilie_wertsteigerung_prozent?.min | number: '1.0-0' }} –
          }
          {{ forecast?.immobilie_wertsteigerung_prozent?.max | number: '1.0-0' }} %</strong>
        <span class="copyright" [innerHTML]="textkeyPrefix + 'immobilie.copyright' | translate"></span>
      </div>
    </div>
  }
  <div class="cell medium-4 cost-savings">
    <img src="/gfx/moc/kostenersparnis.jpg" alt="">
    <div class="cell-content">
      <strong>{{ forecast?.einsparung_energiekosten | number: '1.0-0' }} € </strong>
      <span>
        <span [innerHTML]="textkeyPrefix + 'kostenersparnis' | translate"></span>
        <span class="show-for-small-only">:</span>
      </span>
      <span class="copyright" [innerHTML]="textkeyPrefix + 'kostenersparnis.copyright' | translate"></span>
    </div>
  </div>
  <div class="cell medium-4 co2-savings">
    <img src="/gfx/moc/ersparnis_emissionen.jpg" alt="">
    <div class="cell-content">
      <span [innerHTML]="textkeyPrefix + 'weniger.emissionen' | translate"></span>
      <strong> {{ forecast?.einsparung_co2_tonnen | number: '1.0-0' }} t</strong>
      <span class="copyright" [innerHTML]="textkeyPrefix + 'emissionen.copyright' | translate"></span>
    </div>
  </div>
</div>
